import {
  CloseOutlined,
  DeleteTwoTone,
  FormOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
  SaveOutlined,
  SearchOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Checkbox,
  Col,
  Collapse,
  CollapseProps,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  Tooltip,
  Upload,
} from "antd";
import React, { useContext, useEffect } from "react";
import { useClient } from "../../../Context/ClientContext";
import { notificationContext } from "../../../Common/Routing/PageRoute";

import {
  BusinessNaturesTypeOptions,
  BusinessTypeOptions,
  GSTTypeOptions,
} from "../../Clients/Clients";
import { dayjs } from "../../../../Utilities/dayjs";
import { useUser } from "../../../../Context/UserContext";
import ClientService, {
  BankAccountTypes,
  DeducteeTypes,
  getTDSDeducteeTypeName,
  Product_Module,
} from "../../../Services/ClientService";
import { RcFile } from "antd/es/upload";
import { TypeOfAddress } from "../../../Services/LedgerService";
import { CompanyGSTTypes } from "../../../../Types/CommonConstants";
import { getFYOptions } from "../../Clients/AddClient";
import { AccountTypeDropDown } from "../../../Services/Vendor/VendorRegistrationService";

const SettingsCompanyInfo = () => {
  const {
    companySettings,
    updateCompanySettings,
    updateClientDetails,
    currentClient,
  } = useClient();
  const [companyInfoform] = Form.useForm();
  const { getProducts } = useUser();
  const [contactDetailsForm] = Form.useForm();
  const [paymentTermForm] = Form.useForm();
  const [gstForm] = Form.useForm();
  const [generalForm] = Form.useForm();
  const [gSTTypeValue, setGSTTypeValue] = React.useState<any>(
    CompanyGSTTypes.Regular
  );
  const [disable, setDisable] = React.useState<boolean>(true);
  const [acc, setAcc] = React.useState<boolean>(false);
  const [gstDisable, setGSTDisable] = React.useState<boolean>(true);
  const [generalDisable, setGeneralDisable] = React.useState<boolean>(true);
  const [savebuttonloading, setSaveButtonLoading] =
    React.useState<boolean>(false);
  const [checkbox, setCheckbox] = React.useState<number>(1);
  const { openNotification } = useContext(notificationContext);
  const [infoDisable, setInfoDisable] = React.useState<boolean>(true);
  const [detailsDisable, setDetailsDisable] = React.useState<boolean>(true);
  const [fydate, SetFYDate] = React.useState<string | undefined>("");

  const { getAllIndStates } = useUser();
  const stateOptions: any = getAllIndStates();
  const [saveButtonLoading, setSaveButtonLoadingg] =
    React.useState<boolean>(false);
  const [activeKey, setActiveKey] = React.useState<string[]>([]);
  const [lastClickedPanel, setLastClickedPanel] = React.useState<string | null>(
    null
  );
  const [searchQuery, setSearchQuery] = React.useState<string>("");
  const [activePopover, setActivePopover] = React.useState<any>();
  const [showDetailsTDS, setShowDetailsTDS] = React.useState<boolean>(false);
  const [showDetailsTCS, setShowDetailsTCS] = React.useState<boolean>(false);
  const [checkLogoUploadImg, setCheckLogoUploadImg] = React.useState(false);
  const [uploadImg, setUploadImg] = React.useState<any>(false);
  const [bankTypeValue, setBankTypeValue] = React.useState<BankAccountTypes[]>(
    []
  );
  const [bankDefaultChecked, setBankDefaultChecked] = React.useState<boolean[]>(
    [false]
  );
  const [dataa, setData] = React.useState<any>();
  const [gstLoadingState, setGstLoadingState] = React.useState<boolean>(false);
  const [refresh, setRefresh] = React.useState<boolean>(false);
  const [companyInfo, setCompanyInfo] = React.useState<any>();
  let allProducts = getProducts();
  console.log("allProducts", allProducts);
  const [productData, setProductData] = React.useState<{
    id: string;
    name: string;
    productModule: Product_Module;
  }>({
    id: allProducts![0]?.id,
    name: allProducts![0]?.name,
    productModule: allProducts![0]?.productModule,
  });

  const handleIconClick = (e: React.MouseEvent, panelKey: string) => {
    e.stopPropagation();
    if (!activeKey.includes(panelKey)) {
      setActiveKey([panelKey]);
      setLastClickedPanel(panelKey);
    } else {
    }
  };

  const handleCollapseChange = (key: string | string[]) => {
    if (Array.isArray(key) && key.length > 0 && key[0] === lastClickedPanel) {
      setActiveKey(key as string[]);
    } else {
      setActiveKey(key as string[]);
    }
  };

  const DueOnSubmit = () => {
    paymentTermForm.validateFields().then(async (val: any) => {
      setSaveButtonLoading(true);
      console.log("vall", val);

      const data = {
        ...companyInfo,
        ...val,
      };
      await updateClientDetails!(data, currentClient?.id).then(
        (result: any) => {
          if (result?.status) {
            openNotification("success", "Setting updated successfully.");
            setSaveButtonLoading(false);
            setRefresh((x: boolean) => !x);
            setDisable(true);
          } else {
            setSaveButtonLoading(false);
            openNotification("error", "There is some error.");
          }
        }
      );
    });
  };

  useEffect(() => {
    ClientService.getClient(currentClient?.id).then((res: any) => {
      if (res?.result) {
        console.log("ress", res);
        const set = res?.result;
        SetFYDate(set?.fydate);
        const gst = set?.gst?.map((itm: any) => {
          return {
            title: itm?.rate,
            label: itm?.name,
            value: itm?.id,
          };
        });
        console.log("set", set);

        setShowDetailsTDS(set?.tdsDeductible);
        setShowDetailsTCS(set?.tcsApplicability);
        setData(set?.logo);
        console.log("set", set);
        setCompanyInfo(set);
        setGSTTypeValue(set?.gstType);
        let fyYears = getFYOptions();
        let fyYear = dayjs(res?.result?.financialYearBegin).get("year");
        let fyMonth = dayjs(res?.result?.financialYearBegin).format("MMM");

        const formData = {
          ...set,
          gst: gst,
          gstin: set?.gstin,
          gstType: set?.gstType,
          pan: set?.pan,
          registrationDate: dayjs(set?.gstRegistrationDate),
          state: set?.state,
          gstNumber: set?.gstNumber,
          autoRoundOff: set?.autoRoundOff,
          // businessName: set?.businessName,
          financialYearBegin: fyYears.find(
            (year) => year.label === fyMonth + "-" + fyYear
          )?.value,
          businessType:
            res?.result?.businessType !== 0 && res?.result?.businessType,
          businessStart:
            dayjs(set?.businessStart).unix() > 1 && dayjs(set?.businessStart),

          // bankDetail: Array.isArray(set?.companyInfo?.bankDetail)
          //   ? set?.companyInfo?.bankDetail
          //   : [],
          logo: set?.logo
            ? [
                {
                  uid: set?.logo?.id,
                  name: set?.logo?.name,
                  status: "done",
                },
              ]
            : [],
          companyContactDetails: {
            contactInformation: set?.contactInformation || [],
          },
          dueOn: {
            ...set?.dueOn,
          },
          // gstDetails: {
          //   ...set,
          //   registrationDate: set?.registrationDate
          //     ? dayjs(set?.registrationDate, "dd/mm/yyyy")
          //     : "",
          //   gst: gst,
          // },
        };
        companyInfoform?.setFieldsValue(formData);
        contactDetailsForm?.setFieldsValue(formData);
        paymentTermForm?.setFieldsValue(formData);
        gstForm?.setFieldsValue(formData);
      }
    });
  }, [
    companySettings,
    disable,
    gstDisable,
    infoDisable,
    detailsDisable,
    refresh,
  ]);

  const formFields = [
    { label: "Name", name: "companyInfo.name", key: "1" },
    { label: "Name", name: "name", key: "2" },

    {
      label: "Financial Year Begin on",
      name: "FinancialYearBeginon",
      key: "1",
    },
    { label: "Business Type", name: "companyInfo.businessType", key: "1" },
    { label: "MSME No.", name: "companyInfo.msmeNo.", key: "1" },
    {
      label: "Enable TDS deduction",
      name: "enableTdsdeduction",
      key: "1",
    },
    {
      label: "Enable TCS collection",
      name: "enableTcscollection",
      key: "1",
    },

    { label: "TAN", name: "tan", key: "1" },
    { label: "TDS Deductor Type", name: "tdsDeductortype", key: "1" },
    { label: "TCS Collectee Type", name: "tcsCollecteetype", key: "1" },
    { label: "Alias Name", name: "aliasName", key: "1" },
    { label: "Business Start Date", name: "businessstartdate", key: "1" },
    { label: "Website", name: "website", key: "1" },
    { label: "Company's Logo", name: "company'slogo", key: "1" },
    { label: "Business Nature", name: "accountholdername", key: "1" },
    {
      label: "Account Holder Name",
      name: "accountholdername",
      key: "1",
    },
    {
      label: "Account Number",
      name: "accountnumber",
      key: "1",
    },
    {
      label: "Account Type",
      name: "accounttype",
      key: "1",
    },
    {
      label: "Bank Name",
      name: "bankname",
      key: "1",
    },
    {
      label: "IFSC Code",
      name: "ifsccode",
      key: "1",
    },
    {
      label: "Branch",
      name: "branch",
      key: "1",
    },
    {
      label: "UPI Id",
      name: "upiid",
      key: "1",
    },
    {
      label: "Ledger Name",
      name: "ledgername",
      key: "1",
    },
    {
      label: "Address Name",
      name: "addressName",
      key: "1",
    },
    {
      label: "Address Type",
      name: "addressType",
      key: "1",
    },

    { label: "PAN", name: "pan", key: "4" },
    { label: "RoundOff Type", name: "roundOfftype", key: "5" },
    {
      label: "Show Reverse Charge (RCM)",
      name: "showreversecharge(RCM)",
      key: "5",
    },
    {
      label: "Show RoundOff",
      name: "showroundOff",
      key: "5",
    },

    { label: "GST Number", name: "gstNumber", key: "1" },
    { label: "Building", name: "building", key: "1" },
    { label: "District", name: "district", key: "1" },
    { label: "City", name: "city", key: "1" },
    { label: "Reg. Office", name: "regAddress", key: "1" },

    { label: "Pincode", name: "pincode", key: "1" },
    { label: "State", name: "state", key: "1" },
    { label: "State", name: "state", key: "4" },

    { label: "Phone", key: "2" },
    { label: "Designation", key: "2" },

    { label: "Contact No.", key: "2" },
    { label: "Email", key: "2" },
    { label: "CC", key: "2" },

    { label: "Credit Period", key: "3" },
    { label: "Credit Limit", key: "3" },
    { label: "GST Type", key: "4" },
    { label: "GSTIN", key: "4" },
    { label: "Sales GST Options", key: "4" },
    { label: "Registration Date", key: "4" },

    { label: "Enable Export", key: "5" },
    { label: "Enable RCM (Reverse Charge Mechanism)", key: "5" },
    { label: "Enable Inventory", key: "5" },
  ];

  const findMatchingFieldLabels = (searchQuery: string) => {
    return formFields.filter((field) =>
      field.label.toLowerCase().includes(searchQuery.toLowerCase())
    );
  };

  const highlightLabel = (label: string) => {
    if (!searchQuery) return label;
    const regex = new RegExp(`(${searchQuery})`, "gi");
    const parts = label.split(regex);

    return (
      <span>
        {parts.map((part, index) => {
          // Highlight the matching part
          if (part.toLowerCase() === searchQuery.toLowerCase()) {
            return (
              <span
                key={index}
                style={{
                  color: "white",
                  backgroundColor: "rgb(106 119 227)",
                }}
              >
                {part}
              </span>
            );
          }
          return <span key={index}>{part}</span>;
        })}
      </span>
    );
  };

  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e;
    }
    console.log("normFile", e);
    return e?.fileList;
  };
  const handlePANNo = (e: any) => {
    const { value } = e.target;
    gstForm.setFieldValue("pan", value.slice(2, 12));
    gstForm.setFieldValue("state", Number(value.slice(0, 2)));
  };

  const DeducteeTypesOptions = Object.keys(DeducteeTypes)
    .filter((type) => !isNaN(Number(type)))
    .map((type: any) => {
      return {
        key: Number(type),
        label: getTDSDeducteeTypeName(type),
        value: Number(type),
      };
    });
  const getBase64 = (file: RcFile): Promise<string> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  const handleBeforeUpload = async (file: any) => {
    let base64 = (await getBase64(file as RcFile)).toString();
    file.thumbUrl = base64;
    console.log("base64", base64);
    return false;
  };

  const handleDelBankDetail = (nameIndex: number) => {
    setBankDefaultChecked((prevDetail: any) => {
      let newDetail;
      let selIndex = prevDetail.indexOf(true);
      if (selIndex === -1) {
        newDetail = prevDetail.filter(
          (_: any, index: number) => index !== nameIndex
        );
        newDetail = newDetail.map((d: any) => (d = false));
        newDetail[0] = true;
      } else if (selIndex === nameIndex) {
        newDetail = prevDetail.filter(
          (_: any, index: number) => index !== nameIndex
        );
        if (newDetail !== 0) {
          newDetail[0] = true;
        }
      } else if (selIndex < nameIndex) {
        newDetail = prevDetail.filter(
          (_: any, index: number) => index !== nameIndex
        );
      } else {
        newDetail = prevDetail.filter(
          (_: any, index: number) => index !== nameIndex
        );
        newDetail = newDetail.map((d: any) => (d = false));
        newDetail[selIndex - 1] = true;
      }
      // console.log("Updated BankDetail", newDetail);

      return newDetail;
    });
  };
  const items: CollapseProps["items"] = [
    {
      key: "1",
      label: "Company Information",
      collapsible: "header",
      extra: (
        <>
          {infoDisable && (
            <Tooltip title="Edit">
              <FormOutlined
                className="ca-edit-btn"
                style={{ color: "rgb(106 119 227)" }}
                onClick={(e) => {
                  handleIconClick(e, "1");
                  setInfoDisable(false);
                  setGSTDisable(true);
                  setDisable(true);
                  setDetailsDisable(true);
                }}
              />
            </Tooltip>
          )}
        </>
      ),
      children: (
        <>
          <Form
            //labelCol={{ span: 7 }}
            layout="vertical"
            requiredMark={true}
            form={companyInfoform}
            disabled={infoDisable}
            labelAlign="left"
            autoComplete="off"
            name="companyInfo"
            initialValues={{
              companyInfo: {
                bankDetail: [{}],
                addresses: [{}],
                businessStart: dayjs(), // Ensure it's a dayjs object
              },
            }}
            onFinish={(val) => {
              console.log("valll", val);
              setSaveButtonLoading(true);
              let contactForm = contactDetailsForm.getFieldValue([
                "companyContactDetails",
                "contactInformation",
              ]);

              // console.log("contactForm", contactForm);
              console.log("Company Info", companyInfo);
              // financialYearBegin: val.date.toISOString(),
              // const data: ICompanyInfo = {
              //   ...val?.companyInfo,
              //   financialYearBegin: val?.companyInfo.financialYearBegin.toISOString(),
              // };
              ////////////////////////////////////////////////////////////////
              updateClientDetails!(
                (val = {
                  ...companyInfo,
                  ...val,
                  businessStart: val?.businessStart
                    ? dayjs(val?.businessStart)
                    : dayjs("0000-01-01"),
                  businessType: val?.businessType
                    ? val?.businessType
                    : undefined,
                  fydate: fydate,
                  productModule: productData.productModule,
                  contactInformation: contactForm,
                  gst: companyInfo?.gst,

                  logo:
                    checkLogoUploadImg && val?.logo
                      ? {
                          id: "",
                          name: val?.logo?.[0].name,
                          path: checkLogoUploadImg
                            ? val?.logo[0]?.originFileObj?.thumbUrl
                            : "",
                          length: val?.logo?.[0]?.size,
                          contentType: val?.logo?.[0]?.type,
                        }
                      : uploadImg === true
                      ? null
                      : dataa,
                }),
                currentClient?.id
                // SettingsSections.CompanyInfo,
                // {
                //   ...companySettings,
                //   setting: {
                //     ...companySettings?.setting!,
                //     companyInfo: val?.companyInfo,
                //   },
                // },
              ).then((result: any) => {
                if (result?.status) {
                  setInfoDisable(true);
                  openNotification("success", "Setting updated successfully.");
                  setSaveButtonLoading(false);
                } else {
                  setSaveButtonLoading(false);
                  openNotification("error", "There is some error.");
                }
              });
            }}
          >
            <Form.Item
              className="mb-10"
              name="businessName"
              rules={[{ required: true, message: "Name is required" }]}
              label={highlightLabel("Business Name")}
            >
              <Input />
            </Form.Item>

            <Row justify={"space-between"} gutter={10}>
              <Col span={12}>
                <Form.Item
                  className="mb-10"
                  name="aliasName"
                  // label="Financial Year start"
                  label={highlightLabel("Alias Name")}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="msmeNo"
                  label={highlightLabel("MSME No.")}
                  className="inputBoxMb8"
                  rules={[
                    {
                      pattern:
                        /^(?!.*-00-)(?!.*-0{7}$)^[A-Za-z]{2}-[0-9]{2}-[0-9]{7}$/,
                      message: "Enter valid 19 digit MSME No. including '-'",
                    },
                  ]}
                >
                  <Input
                    addonBefore="UDYAM-"
                    placeholder="XX-00-0123456"
                    minLength={13}
                    maxLength={13}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row justify={"space-between"} gutter={10}>
              <Col span={12}>
                <Form.Item
                  className="mb-10"
                  name="businessType"
                  label={highlightLabel("Business Type")}
                >
                  <Select options={BusinessTypeOptions} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  className="mb-10"
                  name="businessNature"
                  label={highlightLabel("Business Nature")}
                >
                  <Select
                    mode="multiple"
                    options={BusinessNaturesTypeOptions}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={10}>
              <Col span={8}>
                <Form.Item
                  name="tdsDeductible"
                  label={highlightLabel("Enable TDS deduction")}
                  className="inputBoxMb8"
                  valuePropName="checked"
                >
                  <Checkbox
                    onChange={(e) => setShowDetailsTDS(e.target.checked)}
                  />
                </Form.Item>
              </Col>
              {showDetailsTDS && (
                <>
                  <Col span={8}>
                    <Form.Item
                      name="tan"
                      label={highlightLabel("TAN")}
                      className="inputBoxMb8"
                      rules={[
                        {
                          pattern: /^[A-Za-z]{4}[0-9]{5}[A-Za-z]{1}$/,
                          message: "Enter valid 10 alphanumeric TAN number",
                        },
                        {
                          min: 10,
                          max: 10,
                          message: "Length must be 10 characters long",
                        },
                      ]}
                    >
                      <Input
                        placeholder="AAAA99999A"
                        minLength={10}
                        maxLength={10}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      name="tdsDeductorType"
                      label={highlightLabel("TDS Deductor Type")}
                      className="inputBoxMb8 "
                    >
                      <Select options={DeducteeTypesOptions} />
                    </Form.Item>
                  </Col>
                </>
              )}
            </Row>

            <Row gutter={10} justify={"space-between"}>
              <Col span={7}>
                <Form.Item
                  name="tcsApplicability"
                  label={highlightLabel("Enable TCS collection")}
                  className="inputBoxMb8 "
                  valuePropName="checked"
                >
                  <Checkbox
                    onChange={(e) => setShowDetailsTCS(e.target.checked)}
                  />
                </Form.Item>
              </Col>
              {showDetailsTCS && (
                <>
                  <Col span={16}>
                    <Form.Item
                      name="tcsCollecteeType"
                      label={highlightLabel("TCS Collectee Type")}
                      className="inputBoxMb8"
                    >
                      <Select options={DeducteeTypesOptions} />
                    </Form.Item>
                  </Col>
                </>
              )}
            </Row>
            <Row gutter={10}>
              <Col span={12}>
                <Form.Item
                  name="iec"
                  label={highlightLabel("IEC")}
                  className="inputBoxMb8"
                  rules={[
                    {
                      pattern: /^[A-Za-z0-9]{10}$/,
                      message: "Enter valid 10 alphanumeric IEC number",
                    },
                    {
                      min: 10,
                      max: 10,
                      message: "Length must be 10 characters long",
                    },
                  ]}
                >
                  <Input placeholder="IEC Code" minLength={10} maxLength={10} />
                </Form.Item>
              </Col>
            </Row>

            <Divider
              orientation="left"
              orientationMargin="0"
              className="dividertext"
              style={{ marginTop: "11px", marginBottom: "11px" }}
            >
              <p style={{ fontWeight: 600 }}>Business Details</p>
            </Divider>
            <Row gutter={10}>
              <Col span={12}>
                <Form.Item
                  name="businessStart"
                  label={highlightLabel("Business Start Date")}
                  className="inputBoxMb8"
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    format={"DD/MM/YYYY"}
                    disabledDate={(current) =>
                      current < dayjs("1900-01-01", "YYYY-MM-DD").add(-1, "day")
                    }
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  name="website"
                  label={highlightLabel("Website")}
                  className="inputBoxMb8"
                  rules={[
                    {
                      type: "url",
                      message: "Please enter a valid URL",
                    },
                    {
                      min: 10,
                      max: 50,
                      message: "URL length must be minimum 10 or maximum 50",
                    },
                  ]}
                >
                  <Input
                    placeholder="https://www.example.com"
                    minLength={10}
                    maxLength={50}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row justify={"space-between"} gutter={10}>
              <Col span={12}>
                <Form.Item
                  name="logo"
                  label={highlightLabel("Logo")}
                  className="inputBoxMb8"
                  valuePropName="fileList"
                  style={{ margin: "0px", width: "100%" }}
                  getValueFromEvent={normFile}
                >
                  <Upload
                    maxCount={1}
                    beforeUpload={(file: any) => {
                      handleBeforeUpload(file);
                      // handelFile(file);
                      return false;
                    }}
                    accept=".jpg,.jpeg,.png,"
                    style={{ width: "100%" }}
                    onRemove={(e: any) => {
                      setUploadImg(true);
                    }}
                  >
                    <Button
                      onClick={() => setCheckLogoUploadImg(true)}
                      icon={<UploadOutlined />}
                      style={{ width: "323px" }}
                    >
                      Upload
                    </Button>
                  </Upload>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="financialYearBegin"
                  className="inputBoxMb8 inputLabel33"
                  label="Financial year begin on"
                  rules={[
                    {
                      required: true,
                      message: "Please select the financial year begin date",
                    },
                  ]}
                >
                  <Select options={getFYOptions()} style={{ width: "100%" }} />
                </Form.Item>
                {/* <Form.Item
                  className="mb-10"
                  name="financialYearBegin"
                  label={highlightLabel("Financial Year Begin on")}
                  rules={[
                    {
                      required: true,
                      message: "Please input the financial year begin date",
                    },
                    {
                      validator: (_, value) => {
                        let selDate = Number(dayjs(value).date());
                        let selMonth = Number(dayjs(value).month()) + 1;
                        if (selDate === 1 && selMonth === 4) {
                          return Promise.resolve();
                        } else if (selDate === 1 && selMonth === 1) {
                          return Promise.resolve();
                        } else {
                          return Promise.reject(
                            new Error(
                              "Financial year may begin on 1st January or 1st April"
                            )
                          );
                        }
                      },
                    },
                  ]}
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    format="DD/MM/YYYY"
                    onChange={(date: any, dateString: any) => {
                      SetFYDate(dateString);
                    }}
                  />
                </Form.Item> */}
              </Col>
            </Row>

            <Form.List name="bankDetail">
              {(fields, { add, remove }) => (
                <>
                  <Divider
                    orientation="left"
                    orientationMargin="0"
                    className="dividertext"
                    style={{ marginTop: "11px", marginBottom: "11px" }}
                  >
                    <p style={{ fontWeight: 600 }}>Bank Details</p>
                  </Divider>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <div key={index}>
                      <Row gutter={10} justify={"space-between"}>
                        <Col span={12}>
                          <Form.Item
                            name={[name, "accountHolderName"]}
                            className="inputBoxMb8"
                            label={highlightLabel("Account Holder Name")}
                            rules={[
                              {
                                pattern: /^[A-Za-z][ A-Za-z0-9_()&-.,]*$/,
                                message:
                                  "Only alphanumeric with space and some special characters i.e. '_', '(', ')', '&', '-', '.' and ',' are allowed",
                              },
                              {
                                min: 3,
                                max: 80,
                                message:
                                  "Length must be Minimum 3 or Maximum 80 characters long",
                              },
                            ]}
                          >
                            <Input minLength={3} maxLength={80} />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            name={[name, "ledgerName"]}
                            className="inputBoxMb8"
                            label={
                              <Space>
                                {highlightLabel("Ledger Name")}

                                <Tooltip
                                  title="Entered name will be Ledger's name in COA."
                                  placement="top"
                                  color="#4b5b95"
                                >
                                  <QuestionCircleOutlined />
                                </Tooltip>
                              </Space>
                            }
                            rules={[
                              {
                                pattern: /^[A-Za-z][ A-Za-z0-9_()&-.,]*$/,
                                message:
                                  "Only alphanumeric with space and some special characters i.e. '_', '(', ')', '&', '-', '.' and ',' are allowed",
                              },
                              {
                                min: 3,
                                max: 80,
                                message:
                                  "Length must be Minimum 3 or Maximum 80 characters long",
                              },
                            ]}
                          >
                            <Input minLength={3} maxLength={80} />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={10} justify={"space-between"}>
                        <Col span={12}>
                          <Form.Item
                            name={[name, "accountNumber"]}
                            className="inputBoxMb8"
                            label={highlightLabel("Account Number")}
                            rules={[
                              {
                                pattern: new RegExp(/^(?!0+$)\d{6,18}$/),
                                message: "Enter valid account number in digits",
                              },
                              {
                                min: 6,
                                max: 18,
                                message:
                                  "Length must be Minimum 6 or Maximum 18 characters long",
                              },
                            ]}
                          >
                            <Input minLength={6} maxLength={18} />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            name={[name, "accountType"]}
                            label={highlightLabel("Account Type")}
                            className="inputBoxMb8"
                          >
                            <Select
                              placeholder="Account type"
                              onChange={(val) => {
                                const prevBankTypeValue = [...bankTypeValue];
                                prevBankTypeValue[name] = val;
                                setBankTypeValue(prevBankTypeValue);
                              }}
                              options={AccountTypeDropDown}
                              style={{
                                width: window.innerWidth <= 425 ? "226px" : " ",
                              }}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={10} justify={"space-between"}>
                        <Col span={12}>
                          <Form.Item
                            name={[name, "bankName"]}
                            label={highlightLabel("Bank Name")}
                            className="inputBoxMb8"
                            rules={[
                              {
                                pattern: /^[A-Za-z][ A-Za-z0-9_()&-.,]*$/,
                                message:
                                  "Only alphanumeric with space and some special characters i.e. '_', '(', ')', '&', '-', '.' and ',' are allowed",
                              },
                              {
                                min: 3,
                                max: 80,
                                message:
                                  "Length must be Minimum 3 or Maximum 80 characters long",
                              },
                            ]}
                          >
                            <Input minLength={3} maxLength={80} />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            name={[name, "ifsCode"]}
                            label={highlightLabel("IFSC Code")}
                            className="inputBoxMb8"
                            rules={[
                              {
                                pattern: /^[A-Za-z]{4}[0][0-9]{6}$/,
                                message:
                                  "Input valid 11 alphanumeric IFSC code",
                              },
                              {
                                min: 11,
                                max: 11,
                                message: "Length must be 11 characters long",
                              },
                            ]}
                          >
                            <Input
                              placeholder="BANK0123456"
                              maxLength={11}
                              minLength={11}
                              onChange={(e: any) => {
                                const capitalvalue =
                                  e.target.value.toUpperCase();
                                companyInfoform?.setFieldValue(
                                  [name, "ifsCode"],
                                  capitalvalue
                                );
                              }}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={10} justify={"space-between"}>
                        <Col span={12}>
                          <Form.Item
                            name={[name, "branch"]}
                            label={highlightLabel("Branch")}
                            className="inputBoxMb8"
                            rules={[
                              {
                                pattern: /^[A-Za-z][ A-Za-z]*$/,
                                message: "Enter valid branch's name",
                              },
                              {
                                min: 3,
                                max: 50,
                                message:
                                  "Length must be Minimum 3 or Maximum 50 characters long",
                              },
                            ]}
                          >
                            <Input minLength={3} maxLength={50} />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            name={[name, "upiId"]}
                            label={highlightLabel("UPI Id")}
                            className="inputBoxMb8"
                            rules={[
                              {
                                pattern:
                                  /^[a-zA-Z0-9.\-_]{2,40}@[a-zA-Z]{2,20}$/,
                                message: "Please enter a valid UPI Id",
                              },
                              {
                                min: 3,
                                max: 45,
                                message:
                                  "Length must be Minimum 3 or Maximum 45 characters long",
                              },
                            ]}
                          >
                            <Input minLength={3} maxLength={45} />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={10} justify={"space-between"}>
                        {bankTypeValue[index] ===
                          BankAccountTypes.CashCreditAccount ||
                        bankTypeValue[index] ===
                          BankAccountTypes.OverdraftAccount ? (
                          <Col span={12}>
                            <Form.Item
                              name={[name, "odLimit"]}
                              label={
                                bankTypeValue[index] ===
                                BankAccountTypes.CashCreditAccount
                                  ? ` ${highlightLabel("CC Limit")}`
                                  : `${highlightLabel("OD Limit")}`
                              }
                              rules={[
                                {
                                  pattern: /^[0-9]*$/,
                                  message: "Please enter a valid amount",
                                },
                              ]}
                              className="inputBoxMb8"
                            >
                              <Input min={0} />
                            </Form.Item>
                          </Col>
                        ) : (
                          <Col span={12}></Col>
                        )}
                        {/* <Col span={12}> */}
                        {/* <Row justify={"space-between"}> */}
                        {/* <Col span={12}> */}
                        {/* <Form.Item
                                  name={[name, "isDefault"]}
                                  label="Default"
                                  className="inputBoxMb8 inputLabel33"
                                >
                                  <Checkbox
                                    checked={bankDefaultChecked[name]}
                                    onChange={({ target }) => {
                                      setBankDefaultValueHandler(
                                        target.checked,
                                        name
                                      );
                                      //console.log("checkbox result: ", e);
                                    }}
                                  />
                                </Form.Item> */}
                        {/* </Col> */}
                        {/* </Row> */}
                        {/* </Col> */}
                      </Row>
                      <Row justify={"end"}>
                        <Col>
                          <Button
                            style={{
                              padding: "0px",
                              borderColor: "#fff",
                              boxShadow: "none",
                            }}
                            onClick={() => {
                              remove(name);
                              handleDelBankDetail(name);
                            }}
                          >
                            <DeleteTwoTone
                              className="ca-delete-btn"
                              twoToneColor="#ff879d"
                            />
                          </Button>
                        </Col>
                      </Row>
                      <Divider style={{ margin: "7px" }} />
                    </div>
                  ))}
                  <Form.Item className="inputBoxMb">
                    <Row key={"add Bank Detail"}>
                      <Col>
                        <Button
                          type="link"
                          onClick={() => add()}
                          block
                          icon={<PlusOutlined />}
                        >
                          Add Bank Detail
                        </Button>
                      </Col>
                    </Row>
                  </Form.Item>
                </>
              )}
            </Form.List>

            {/* 
            {highlightLabel("Reg. Office")}
            <Row gutter={18}>
              <Col xl={8} xxl={8} lg={8}>
                <Form.Item
                  name={["companyInfo", "regAddress", "building"]}
                  className="mb-10"
                >
                  <Input placeholder="Building" />
                </Form.Item>
              </Col>
              <Col xl={8} xxl={8} lg={8}>
                <Form.Item
                  name={["companyInfo", "regAddress", "district"]}
                  className="mb-10"
                >
                  <Input placeholder="District" />
                </Form.Item>
              </Col>
              <Col xl={8} xxl={8} lg={8}>
                <Form.Item
                  name={["companyInfo", "regAddress", "city"]}
                  className="mb-10"
                >
                  <Input placeholder="City" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={18}>
              <Col xl={8} xxl={8} lg={8}>
                <Form.Item
                  name={["companyInfo", "regAddress", "pincode"]}
                  className="mb-10"
                >
                  <Input placeholder="Pincode" />
                </Form.Item>
              </Col>
              <Col xl={16} xxl={16} lg={16}>
                <Form.Item
                  name={["companyInfo", "regAddress", "state"]}
                  className="mb-10"
                >
                  <Select
                    showSearch
                    placeholder="State"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={Object.entries(stateOptions)?.map(
                      ([key, x]: any) => ({
                        value: x?.id,
                        label: x?.name,
                      })
                    )}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={18}>
              <Col xl={8} xxl={8} lg={8}>
                <Form.Item
                  name={["companyInfo", "regAddress", "landmark"]}
                  className="mb-10"
                >
                  <Input placeholder="Landmark" />
                </Form.Item>
              </Col>
              <Col xl={8} xxl={8} lg={8}>
                <Form.Item
                  name={["companyInfo", "regAddress", "street"]}
                  className="mb-10"
                >
                  <Input placeholder="Street" />
                </Form.Item>
              </Col>
              <Col xl={8} xxl={8} lg={8}>
                <Form.Item
                  name={["companyInfo", "regAddress", "country"]}
                  className="mb-10"
                >
                  <Input placeholder="Country" />
                </Form.Item>
              </Col>
            </Row> */}
            <div>
              <Form.List name="addresses">
                {(fields, { add, remove }) => (
                  <>
                    <Divider
                      orientation="left"
                      orientationMargin="0"
                      className="dividertext"
                      style={{
                        marginTop: "11px",
                        marginBottom: "11px",
                        fontWeight: 600,
                      }}
                    >
                      Address Details
                    </Divider>
                    {fields.map(({ key, name, ...restField }, index) => (
                      <div key={key}>
                        <Row
                          key={key}
                          gutter={10}
                          // style={{
                          //   justifyContent: width <= 375 ? "center" : "",
                          // }}
                          justify={"space-between"}
                        >
                          <Col span={12}>
                            <Form.Item
                              name={[name, "type"]}
                              label={highlightLabel("Address Type")}
                              className="inputBoxMb  inputBoxMb8"
                              // rules={[
                              //   {
                              //     required: true,
                              //     message: "Please Select Address Type",
                              //   },
                              // ]}
                            >
                              <Select
                                placeholder="Type"
                                options={[
                                  {
                                    label: "Registered Address",
                                    value: TypeOfAddress.RegisteredAddress,
                                  },
                                  {
                                    label: "Business Address",
                                    value: TypeOfAddress.BusinessAddress,
                                  },
                                  {
                                    label: "Branch Address",
                                    value: TypeOfAddress.BranchAddress,
                                  },
                                  {
                                    label: "Unit Address",
                                    value: TypeOfAddress.UnitAddress,
                                  },
                                  {
                                    label: "Godown Address",
                                    value: TypeOfAddress.GodownAddress,
                                  },
                                ]}
                                style={{
                                  width:
                                    window.innerWidth <= 425 ? "226px" : " ",
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item
                              name={[name, "addressName"]}
                              label={highlightLabel("Address Name")}
                              className="inputBoxMb8"
                              rules={[
                                {
                                  pattern: /^[A-Za-z][ A-Za-z0-9_()&-]*$/,
                                  message:
                                    "Only alphanumeric with space and some special characters i.e. '_', '(', ')', '&' and '-' are allowed",
                                },
                                {
                                  required: true,
                                  message: "Please assign a name to address",
                                },
                                {
                                  min: 2,
                                  max: 20,
                                  message:
                                    "Length must be Minimum 2 or Maximum 20 characters long",
                                },
                              ]}
                            >
                              <Input minLength={2} maxLength={20} />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={10} justify={"space-between"}>
                          <Col span={12}>
                            <Form.Item
                              name={[name, "address", "building"]}
                              className="inputBoxMb inputBoxMb8"
                              rules={[
                                {
                                  max: 150,
                                  message: "Maximum 150 characters are allowed",
                                },
                              ]}
                            >
                              <Input placeholder="Building" maxLength={150} />
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item
                              name={[name, "address", "street"]}
                              className="inputBoxMb inputBoxMb8"
                              rules={[
                                {
                                  max: 150,
                                  message: "Maximum 150 characters are allowed",
                                },
                              ]}
                            >
                              <Input placeholder="Street" maxLength={150} />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row justify={"space-between"} gutter={10}>
                          <Col span={12}>
                            <Form.Item
                              name={[name, "address", "landmark"]}
                              className="inputBoxMb inputBoxMb8"
                              rules={[
                                {
                                  max: 150,
                                  message: "Maximum 150 characters are allowed",
                                },
                              ]}
                            >
                              <Input
                                maxLength={150}
                                // className="inputBgColor"
                                placeholder="Landmark"
                              />
                            </Form.Item>
                          </Col>

                          <Col span={12}>
                            <Form.Item
                              name={[name, "address", "city"]}
                              className="inputBoxMb inputBoxMb8"
                              rules={[
                                {
                                  pattern: /^[A-Za-z][ A-Za-z()&]*$/,
                                  message:
                                    "Only alphabets with space and some special characters i.e. '(', ')' and '&' are allowed",
                                },
                                {
                                  min: 3,
                                  max: 30,
                                  message:
                                    "Length must be Minimum 3 or Maximum 30 characters",
                                },
                              ]}
                            >
                              <Input
                                // className="inputBgColor"
                                placeholder="City"
                                minLength={3}
                                maxLength={30}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row justify={"space-between"} gutter={10}>
                          <Col span={12}>
                            <Form.Item
                              name={[name, "address", "pincode"]}
                              className="inputBoxMb inputBoxMb8"
                              rules={[
                                {
                                  pattern: /^\d{6}$/,
                                  message: "Please enter valid 6 digit Pincode",
                                },
                                {
                                  min: 6,
                                  max: 6,
                                  message: "Length must be 6 digits long",
                                },
                              ]}
                            >
                              <Input
                                // controls={false}
                                style={{ width: "100%" }}
                                // className="inputBgColor"
                                placeholder="Pincode"
                                maxLength={6}
                                minLength={6}
                                // onChange={(e) => {
                                //   const newValue = e.target.value.replace(
                                //     /[^0-9]/g,
                                //     ""
                                //   );
                                //   form.setFieldValue([name,"address", "pincode"],
                                //     newValue
                                //   );
                                //   console.log(
                                //     "Current form values:",
                                //     form.getFieldsValue()
                                //   );
                                // }}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={12}>
                            <Form.Item
                              className="inputBoxMb inputBoxMb8"
                              name={[name, "address", "district"]}
                              rules={[
                                {
                                  pattern: /^[A-Za-z][ A-Za-z()&]*$/,
                                  message:
                                    "Only alphabets with space and some special characters i.e. '(', ')' and '&' are allowed",
                                },
                                {
                                  min: 3,
                                  max: 30,
                                  message:
                                    "Length must be Minimum 3 or Maximum 30 characters",
                                },
                              ]}
                            >
                              <Input
                                // className="inputBgColor"
                                placeholder="District"
                                minLength={3}
                                maxLength={30}
                              />
                            </Form.Item>
                          </Col>
                        </Row>

                        <Row gutter={10} justify={"space-between"}>
                          <Col span={12}>
                            <Form.Item
                              name={[name, "address", "state"]}
                              className="inputBoxMb inputBoxMb8"
                              // rules={[
                              //   {
                              //     required: true,
                              //     message: "Please select State",
                              //   },
                              // ]}
                            >
                              <Select
                                showSearch
                                placeholder="Please select State"
                                options={Object.entries(stateOptions)?.map(
                                  ([key, x]: any) => ({
                                    value: x?.id,
                                    label: x?.name,
                                  })
                                )}
                                filterOption={(input, option) =>
                                  (option?.label.toString() ?? "")
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                              />
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item
                              name={[name, "address", "country"]}
                              className="inputBoxMb inputBoxMb8"
                              rules={[
                                {
                                  pattern: /^[A-Za-z][ A-Za-z()&]*$/,
                                  message:
                                    "Only alphabets with space and some special characters i.e. '(', ')' and '&' are allowed",
                                },
                                {
                                  min: 3,
                                  max: 30,
                                  message:
                                    "Length must be Minimum 3 or Maximum 30 characters",
                                },
                              ]}
                            >
                              <Input
                                placeholder="Country"
                                minLength={3}
                                maxLength={30}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={10} justify={"end"}>
                          <Col
                            className="pb"
                            style={{
                              textAlign: "end",
                              paddingTop: "10px",
                              paddingRight: "19px",
                            }}
                          >
                            {name > 0 && (
                              <Button
                                style={{
                                  padding: "0px",
                                  borderColor: "#fff",
                                  boxShadow: "none",
                                }}
                                onClick={() => remove(name)}
                              >
                                <DeleteTwoTone
                                  className="ca-delete-btn"
                                  twoToneColor="#ff879d"
                                />
                              </Button>
                            )}
                          </Col>
                        </Row>
                        <Divider style={{ margin: "7px" }} />
                      </div>
                    ))}
                    <Form.Item className="inputBoxMb">
                      <Row key={"add contact"}>
                        <Col>
                          <Button
                            type="link"
                            onClick={() => add()}
                            block
                            icon={<PlusOutlined />}
                            //disabled={fields[4]?.name === 4 ? true : false}
                          >
                            Add Address
                          </Button>
                        </Col>
                      </Row>
                    </Form.Item>
                  </>
                )}
              </Form.List>
            </div>

            {/* <Row></Row> */}
            <Row justify="end" style={{ height: 32 }}>
              {!infoDisable && (
                <Space>
                  <Button
                    icon={<CloseOutlined />}
                    style={{ backgroundColor: "aliceblue" }}
                    onClick={() => setInfoDisable(true)}
                  >
                    Cancel
                  </Button>
                  <Form.Item className="m-0">
                    <Button
                      icon={<SaveOutlined />}
                      type="primary"
                      htmlType="submit"
                      loading={savebuttonloading}
                    >
                      Save
                    </Button>
                  </Form.Item>
                </Space>
              )}
            </Row>
          </Form>
        </>
      ),
    },
    {
      key: "2",
      label: "Contact Details",
      collapsible: "header",
      extra: (
        <>
          <Row>
            {detailsDisable && (
              <Tooltip title="Edit">
                <FormOutlined
                  className="ca-edit-btn"
                  style={{ color: "rgb(106 119 227)" }}
                  onClick={(e) => {
                    handleIconClick(e, "2");
                    setDetailsDisable(false);
                    setGSTDisable(true);
                    setInfoDisable(true);
                    setDisable(true);
                  }}
                />
              </Tooltip>
            )}
          </Row>
        </>
      ),
      children: (
        <>
          <Form
            layout="vertical"
            requiredMark={false}
            form={contactDetailsForm}
            disabled={detailsDisable}
            initialValues={{
              companyContactDetails: {
                contactInformation: [{}],
              },
              // contactInformation: [{}],
            }}
            autoComplete="off"
            name="companyContactDetails"
            onFinish={(val) => {
              console.log("val", val);
              let data = {
                ...companyInfo,
                contactInformation:
                  val?.companyContactDetails?.contactInformation,
                productModule: productData.productModule,
              };
              setSaveButtonLoadingg(true);
              updateClientDetails!(
                // SettingsSections.ContactDetails,
                // {
                //   ...companySettings,
                //   setting: {
                //     ...companySettings?.setting!,
                //     companyContactDetails: val?.companyContactDetails,
                //   },
                // },
                data,
                currentClient?.id
              )
                .then((result: any) => {
                  if (result?.status) {
                    setDetailsDisable(true);
                    openNotification(
                      "success",
                      "Setting updated successfully."
                    );
                    setSaveButtonLoadingg(false);
                  } else {
                    setSaveButtonLoadingg(false);
                    openNotification("error", "There is some error.");
                  }
                })
                .catch((ex: any) => {
                  setSaveButtonLoadingg(false);
                  openNotification("error", ex.message);
                });
            }}
          >
            {/* <span
              style={{
                fontWeight:
                  searchQuery && searchQuery.toLowerCase() === "phone"
                    ? 800
                    : "",
              }}
            >
              Phone
            </span> */}
            {/* <Form.Item
              className="mb-10"
              label={highlightLabel("Phone")}
              name={["companyContactDetails", "phone"]}
              labelAlign="left"
              rules={[{ min: 10, message: "Phone No. must be 10 digits long" }]}
            >
              <Input
                onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
                maxLength={10}
              />
            </Form.Item>
            <Form.Item
              label={highlightLabel("Mobile")}
              className="mb-10"
              name={["companyContactDetails", "mobile"]}
              rules={[
                {
                  required: true,
                  message: "Please input mobile number",
                },
                { min: 10, message: "Mobile No. must be of 10 digits long" },
              ]}
            >
              <Input
                onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
                maxLength={10}
              />
            </Form.Item>
            <Form.Item
              label={highlightLabel("Email")}
              className="mb-10"
              name={["companyContactDetails", "email"]}
              rules={[
                {
                  required: true,
                  message: "Please input valid email",
                },
                {
                  pattern: /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/,
                  message: "Please enter a valid email address",
                },
              ]}
            >
              <Input />
            </Form.Item> */}

            <Form.List name={["companyContactDetails", "contactInformation"]}>
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <div key={key}>
                      <Row justify={"space-between"} gutter={10}>
                        <Col span={12}>
                          <Form.Item
                            label={highlightLabel("Name")}
                            className="inputBoxMb8"
                            name={[name, "name"]}
                            {...restField}
                            rules={[
                              {
                                pattern: /^[A-Za-z][ A-Za-z0-9_()&-]*$/,
                                message:
                                  "Only alphanumeric with space and some special characters i.e. '_', '(', ')', '&' and '-' are allowed",
                              },
                              {
                                min: 3,
                                max: 30,
                                message:
                                  "Length must be Minimum 3 or Maximum 30 characters",
                              },
                            ]}
                            // className="inputBoxMb8"
                          >
                            <Input
                              placeholder="Name"
                              minLength={3}
                              maxLength={30}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            name={[name, "designation"]}
                            label={highlightLabel("Designation")}
                            {...restField}
                            className="inputBoxMb8"
                            rules={[
                              {
                                pattern: /^[A-Za-z][ A-Za-z0-9_()&-]*$/,
                                message:
                                  "Only alphanumeric with space and some special characters i.e. '_', '(', ')', '&' and '-' are allowed",
                              },
                              {
                                min: 3,
                                max: 30,
                                message:
                                  "Length must be Minimum 3 or Maximum 30 characters",
                              },
                            ]}
                            // className="inputBoxMb8"
                          >
                            <Input
                              placeholder="Designation"
                              minLength={3}
                              maxLength={30}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row justify={"space-between"} gutter={10}>
                        <Col span={12}>
                          <Form.Item
                            label={highlightLabel("Contact No.")}
                            name={[name, "phone"]}
                            {...restField}
                            className="inputBoxMb8"
                            rules={[
                              {
                                message: "Enter valid Phone No.",
                                pattern: /^[6-9]{1}[0-9]{9}$/,
                              },
                            ]}
                          >
                            <Input
                              placeholder="9876543210"
                              minLength={10}
                              maxLength={10}
                              // suffix={
                              //   <img src={phoneImg} alt="phone"></img>
                              // }
                              // addonBefore={
                              //   <Form.Item
                              //     name={[name, "prefix"]}
                              //     {...restField}
                              //     noStyle
                              //   >
                              //     <Select
                              //       style={{ width: 67 }}
                              //       options={[
                              //         { value: "0", label: "+81" },
                              //         { value: "1", label: "+91" },
                              //       ]}
                              //     />
                              //   </Form.Item>
                              // }
                              style={{
                                width: window.innerWidth <= 425 ? "160px" : "",
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            label={highlightLabel("Email")}
                            name={[name, "email"]}
                            {...restField}
                            className="inputBoxMb8"
                            rules={[
                              {
                                type: "email",
                                message: "Enter valid email address",
                              },
                              {
                                min: 10,
                                max: 80,
                                message:
                                  "Length must be Minimum 10 or Maximum 80 characters",
                              },
                            ]}
                          >
                            <Input
                              placeholder="user@example.com"
                              minLength={10}
                              maxLength={80}
                              style={{
                                width: window.innerWidth <= 425 ? "180px" : "",
                              }}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={10}>
                        <Col span={12}>
                          <Form.Item
                            label={highlightLabel("CC")}
                            name={[name, "ccTo"]}
                            {...restField}
                            className="inputBoxMb8"
                            rules={[
                              {
                                type: "email",
                                message: "Enter valid email address",
                              },
                              {
                                min: 10,
                                max: 250,
                                message:
                                  "Length must be Minimum 10 or Maximum 250 characters",
                              },
                            ]}
                          >
                            <Input
                              placeholder="user@example.com"
                              minLength={10}
                              maxLength={250}
                              style={{
                                width: window.innerWidth <= 425 ? "180px" : "",
                              }}
                            />
                          </Form.Item>
                        </Col>
                        {/* <Col span={2}>
                          <Form.Item className="inputBoxMb8">
                            <Checkbox
                              style={{ paddingTop: "27px" }}
                              // checked={checkbox === index}
                              // onChange={() => {
                              //   if (checkbox !== index) {
                              //     setCheckbox(index);
                              //     console.log("checkbox", checkbox);
                              //     console.log("index", index);
                              //   }
                              // }}
                            />
                          </Form.Item>
                        </Col> */}
                        <Col span={6}>
                          {fields.length > 1 && (
                            <Button
                              style={{
                                padding: "0px",
                                borderColor: "#fff",
                                boxShadow: "none",
                                marginTop: "22px",
                              }}
                            >
                              <DeleteTwoTone
                                className="ca-delete-btn"
                                onClick={() => {
                                  // if (index === 0 && checkbox !== 0) {
                                  //   setCheckbox(checkbox - 1);
                                  // } else if (
                                  //   checkbox === 0 &&
                                  //   fields.length > 1
                                  // ) {
                                  //   // console.log("first delete");
                                  //   setCheckbox(0);
                                  // } else if (
                                  //   checkbox !== 0 &&
                                  //   checkbox !== 4
                                  // ) {
                                  //   // console.log("center delete");
                                  //   checkbox !== index - 1 &&
                                  //     setCheckbox(checkbox - 1);
                                  // } else if (
                                  //   fields.length === index + 1 &&
                                  //   fields.length !== 1
                                  // ) {
                                  //   // console.log("// last Delete");
                                  //   setCheckbox(index - 1);
                                  // } else if (
                                  //   fields.length === index + 1 &&
                                  //   fields.length !== 1
                                  // ) {
                                  //   setCheckbox(index - 1);
                                  // }
                                  return fields.length === 1
                                    ? ""
                                    : remove(name);
                                }}
                                twoToneColor="#ff879d"
                              />
                            </Button>
                          )}
                        </Col>
                      </Row>
                      <Divider style={{ margin: "7px" }} />
                    </div>
                  ))}

                  <Form.Item className="inputBoxMb">
                    <Row>
                      <Col>
                        <Button
                          type="link"
                          onClick={() => add()}
                          block
                          icon={<PlusOutlined />}
                        >
                          Add Contact
                        </Button>
                      </Col>
                    </Row>
                  </Form.Item>
                </>
              )}
            </Form.List>
            <Row justify="end" style={{ height: 32 }}>
              {!detailsDisable && (
                <Space>
                  <Button
                    icon={<CloseOutlined />}
                    style={{ backgroundColor: "aliceblue" }}
                    onClick={() => setDetailsDisable(true)}
                  >
                    Cancel
                  </Button>

                  <Button
                    icon={<SaveOutlined />}
                    type="primary"
                    htmlType="submit"
                    loading={saveButtonLoading}
                  >
                    Save
                  </Button>
                </Space>
              )}
            </Row>
          </Form>
        </>
      ),
    },
    {
      key: "3",
      label: "Payment Term",
      collapsible: "header",
      extra: (
        <>
          {disable && (
            <Tooltip title="Edit">
              <FormOutlined
                style={{ color: "rgb(106 119 227)" }}
                className="ca-edit-btn"
                onClick={(e) => {
                  handleIconClick(e, "3");
                  setGSTDisable(true);
                  setInfoDisable(true);
                  setDisable(false);
                  setDetailsDisable(true);
                }}
              />
            </Tooltip>
          )}
        </>
      ),
      children: (
        <>
          <Form
            requiredMark={false}
            labelAlign="left"
            form={paymentTermForm}
            name="dueOn"
            colon={false}
            disabled={disable}
            layout="vertical"
          >
            <Form.Item className="input-setting-paymentTerm">
              {/* <Checkbox
              style={{ paddingRight: "20px" }}
              checked={checkbox === 1}
              onChange={() => {
                if (checkbox !== 1) {
                  setCheckbox(1);
                }
              }}
            /> */}

              <Form.Item
                label={highlightLabel("Credit Period (days)")}
                name="duration"
                className="input-setting-paymentTerm"
                // labelCol={{ span: 7 }}
                // wrapperCol={{ span: 13 }}
                rules={[
                  {
                    required: true,
                    message: "Enter days in number",
                  },
                ]}
              >
                <InputNumber
                  style={{ width: "200px" }}
                  min={0}
                  max={365}
                  placeholder="0"
                  controls={false}
                  onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
                />
              </Form.Item>

              {/* <Col span={7}>
                  <Form.Item
                    name="durationUnit"
                    className="input-setting-paymentTerm"
                    labelCol={{ span: 7 }}
                    wrapperCol={{ span: 13 }}
                  >
                    <Select
                      // disabled={checkbox !== 1}
                      defaultValue="Days"
                      options={[
                        { label: "Days", value: 0 },
                        { label: "Weeks", value: 1 },
                        { label: "Months", value: 2 },
                        { label: "Years", value: 3 },
                      ]}
                    />
                  </Form.Item>
                </Col> */}
              <Form.Item
                label={highlightLabel("Credit Limit ( ₹ )")}
                name="creditLimit"
                // labelCol={{ span: 7 }}
                // wrapperCol={{ span: 13 }}
              >
                <InputNumber
                  style={{ width: "200px" }}
                  min={0}
                  max={999999999}
                  controls={false}
                  placeholder="Enter amount"
                  onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
                />
              </Form.Item>
            </Form.Item>
            {/* <Row>
          <Checkbox
            style={{ paddingRight: "20px" }}
            checked={checkbox === 2}
            onChange={() => {
              if (checkbox !== 2) {
                setCheckbox(2);
              }
            }}
          />

           <Col span={2} style={{ paddingRight: "10px" }}>
            <Form.Item name="ordinal" className="input-setting-paymentTerm">
              <Select
                disabled={checkbox !== 2}
                defaultValue="Last"
                options={[
                  { label: "Last", value: 0 },
                  { label: "1st", value: 1 },
                  { label: "2nd", value: 2 },
                  { label: "3rd", value: 3 },
                  { label: "4th", value: 4 },
                  { label: "5th", value: 5 },
                  { label: "6th", value: 6 },
                  { label: "7th", value: 7 },
                  { label: "8th", value: 8 },
                  { label: "9th", value: 9 },
                  { label: "10th", value: 10 },
                  { label: "11th", value: 11 },
                  { label: "12th", value: 12 },
                  { label: "13th", value: 13 },
                  { label: "14th", value: 14 },
                  { label: "15th", value: 15 },
                  { label: "16th", value: 16 },
                  { label: "17th", value: 17 },
                  { label: "18th", value: 18 },
                  { label: "19th", value: 19 },
                  { label: "20th", value: 20 },
                  { label: "21th", value: 21 },
                  { label: "22th", value: 22 },
                  { label: "23th", value: 23 },
                  { label: "24th", value: 24 },
                  { label: "25th", value: 25 },
                  { label: "26th", value: 26 },
                  { label: "27th", value: 27 },
                  { label: "28th", value: 28 },
                  { label: "29th", value: 29 },
                  { label: "30th", value: 30 },
                  { label: "31th", value: 31 },
                ]}
              />
            </Form.Item>
          </Col>
          <Col span={2} style={{ paddingRight: "10px" }}>
            <Form.Item name="ordinalUnit" className="input-setting-paymentTerm">
              <Select
                disabled={checkbox !== 2}
                defaultValue="Monday"
                options={[
                  { label: "Sunday", value: 0 },
                  { label: "Monday", value: 1 },
                  { label: "Thesday", value: 2 },
                  { label: "Wednesday", value: 3 },
                  { label: "Thursday", value: 4 },
                  { label: "Friday", value: 5 },
                  { label: "Saturday", value: 6 },
                  { label: "Day", value: 1 },
                ]}
              />
            </Form.Item>
          </Col>
          <Col span={3} style={{ paddingRight: "10px" }}>
            <Form.Item
              label="of the"
              name="ordinalTarget"
              className="input-setting-paymentTerm"
            >
              <Select
                disabled={checkbox !== 2}
                defaultValue="Next"
                options={[
                  { label: "Current", value: 0 },
                  { label: "Next", value: 1 },
                ]}
              />
            </Form.Item>
          </Col>
          <Col span={2}>
            <Form.Item
              name="durationUnit"
              className="input-setting-paymentTerm"
            >
              <Select
                disabled={checkbox !== 2}
                defaultValue="Week"
                options={[
                  { label: "Week", value: 1 },
                  { label: "Month", value: 2 },
                  { label: "Years", value: 3 },
                ]}
              />
            </Form.Item>
          </Col> 
        </Row> */}

            {/* <Checkbox
          style={{ gap: "20px", paddingBottom: "15px" }}
          checked={checkbox === 3}
          onChange={() => {
            if (checkbox !== 3) {
              setCheckbox(3);
            }
          }}
        />
        <span>Due on receipt</span> */}
          </Form>
          {!disable && (
            <Space style={{ justifyContent: "end", display: "flex" }}>
              <Button icon={<CloseOutlined />} onClick={() => setDisable(true)}>
                Cancel
              </Button>

              <Button
                type="primary"
                loading={savebuttonloading}
                onClick={() => {
                  DueOnSubmit();
                }}
                icon={<SaveOutlined />}
              >
                Save
              </Button>
            </Space>
          )}
        </>
      ),
    },
    {
      key: "4",
      label: "GST",
      collapsible: "header",
      extra: (
        <>
          {gstDisable && (
            <Tooltip title="Edit">
              <FormOutlined
                className="ca-edit-btn"
                style={{ color: "rgb(106 119 227)" }}
                onClick={(e) => {
                  handleIconClick(e, "4");
                  setGSTDisable(false);
                  setInfoDisable(true);
                  setDisable(true);
                  setDetailsDisable(true);
                }}
              />
            </Tooltip>
          )}
        </>
      ),
      children: (
        <>
          <Form
            requiredMark={false}
            form={gstForm}
            labelAlign="left"
            disabled={gstDisable}
            autoComplete="off"
            layout="vertical"
            name="Gst"
            onFinish={(val) => {
              const gst = val?.gstDetails?.gst?.map((itm: any) => {
                return {
                  id: itm?.value,
                  name: itm?.label,
                  rate: itm?.title,
                };
              });

              // const data: any = {
              //   ...val?.gstDetails,
              //   registrationDate: dayjs(
              //     val?.gstDetails?.registrationDate
              //   ).toISOString(),
              //   gst: gst,
              // isGSTEnabled:
              //   gst?.length > 0 &&
              //   (val?.registrationNo !== "" || val?.registrationNo !== null)
              //     ? true
              //     : false,
              // };
              console.log("data");
              console.log("val", val);

              let data = {
                ...companyInfo,
                ...val,
                gst: val?.gst?.map((itm: any) => {
                  return {
                    id: itm?.value,
                    name: itm?.label,
                    rate: itm?.title,
                  };
                }),
                isGSTEnabled:
                  gst?.length > 0 &&
                  (val?.registrationNo !== "" || val?.registrationNo !== null)
                    ? true
                    : false,
                productModule: productData.productModule,
              };

              setSaveButtonLoading(true);
              updateClientDetails!(
                // SettingsSections.GstDetails,
                // {
                //   ...companySettings,
                //   setting: {
                //     ...companySettings?.setting!,
                //     gstDetails: data?.gstDetails,
                //   },
                // },
                data,
                currentClient?.id
              )
                .then((result: any) => {
                  if (result?.status) {
                    openNotification(
                      "success",
                      "Setting updated successfully."
                    );
                    setGSTDisable(true);
                    setSaveButtonLoading(false);
                  } else {
                    openNotification("error", "There is some error.");
                    setSaveButtonLoading(false);
                  }
                })
                .catch((ex: any) => {
                  setSaveButtonLoading(false);
                  openNotification("error", ex.message);
                });
            }}
          >
            <Form.Item
              label={highlightLabel("GST Type")}
              name="gstType"
              className="inputBoxMb8"
              rules={[
                {
                  required: true,
                  message: "Please select the appropriate GST type",
                },
              ]}
            >
              <Select
                onChange={(val) => {
                  setGSTTypeValue(val);
                }}
                options={GSTTypeOptions.filter(
                  (gst: any) =>
                    gst.value !== CompanyGSTTypes.SEZ &&
                    gst.value !== CompanyGSTTypes.Overseas &&
                    gst.value !== CompanyGSTTypes.Consumer &&
                    gst.value !== CompanyGSTTypes.DeemedExportImport
                )}
              />
            </Form.Item>
            <>
              {gSTTypeValue !== CompanyGSTTypes.Unregistered &&
                gSTTypeValue !== CompanyGSTTypes.Consumer && (
                  <Form.Item
                    label={highlightLabel("GST Registration Date")}
                    className="mb-10"
                    name="registrationDate"
                    rules={[
                      {
                        required: true,
                        message: "Please input date",
                      },
                    ]}
                  >
                    <DatePicker
                      style={{ width: "100%" }}
                      format={"DD/MM/YYYY"}
                      disabledDate={(current) =>
                        current <
                        dayjs("1900-01-01", "YYYY-MM-DD").add(-1, "day")
                      }
                    />
                  </Form.Item>
                )}

              {gSTTypeValue !== CompanyGSTTypes.Unregistered &&
                gSTTypeValue !== CompanyGSTTypes.Consumer && (
                  <>
                    <Form.Item
                      name="gstin"
                      className="inputBoxMb8 inputLabel33"
                      label="GSTIN"
                      rules={[
                        {
                          required: true,
                          message: "GST number is required",
                        },
                        {
                          pattern:
                            /^(?!00)[0-9]{2}[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}[1-9A-Za-z]{1}Z[0-9A-Za-z]{1}$/,
                          message: "Enter valid 15 alphanumeric GST number",
                        },
                        {
                          min: 15,
                          max: 15,
                          message: "Length must be 15 characters long",
                        },
                      ]}
                    >
                      <Input
                        placeholder="01AABCC1234D1ZZ"
                        maxLength={15}
                        minLength={15}
                        allowClear={true}
                        onChange={(e: any) => {
                          const capitalvalue = e.target.value.toUpperCase();
                          gstForm.setFieldValue("gstin", capitalvalue);
                        }}
                        onBlur={handlePANNo}
                      />
                    </Form.Item>
                  </>
                )}

              {/* {gSTTypeValue !== CompanyGSTTypes.Unregistered &&
                gSTTypeValue !== CompanyGSTTypes.Consumer && (
                  <Form.Item
                    label={highlightLabel("Sales GST Options")}
                    className="mb-10"
                    name="gst"
                    rules={[
                      {
                        required: true,
                        message: "Please input GST options",
                      },
                    ]}
                  >
                    <Select
                      labelInValue
                      showSearch={false}
                      mode="multiple"
                      allowClear
                      style={{ width: "100%" }}
                      placeholder="Please select GSTs"
                      onChange={(val) => console.log(val)}
                      options={companySettings?.gsts?.map((gst: any) => ({
                        title: gst?.rate,
                        value: gst?.id,
                        label: gst?.name,
                      }))}
                    />
                  </Form.Item>
                )} */}
              <>
                <Form.Item
                  name="state"
                  label={highlightLabel("State")}
                  className="inputBoxMb8"
                  rules={[
                    {
                      required:
                        gSTTypeValue === CompanyGSTTypes.Unregistered ||
                        gSTTypeValue === CompanyGSTTypes.Consumer
                          ? true
                          : false,
                      message: "Please select the State",
                    },
                  ]}
                >
                  <Select
                    // disabled={
                    //   gSTTypeValue === CompanyGSTTypes.Regular ||
                    //   gSTTypeValue === CompanyGSTTypes.Composition
                    //     ? true
                    //     : false
                    // }
                    showSearch
                    placeholder="Please select State"
                    options={Object.entries(stateOptions)?.map(
                      ([key, x]: any) => ({
                        value: x?.id,
                        label: x?.name,
                      })
                    )}
                    filterOption={(input, option) =>
                      (option?.label.toString() ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    style={{
                      width: window.innerWidth <= 425 ? "226px" : " ",
                    }}
                  />
                </Form.Item>
                <Form.Item
                  className="mb-10"
                  name="pan"
                  // label="PAN"
                  label={highlightLabel("PAN")}
                  rules={[
                    {
                      required:
                        gSTTypeValue === CompanyGSTTypes.Unregistered ||
                        gSTTypeValue === CompanyGSTTypes.Consumer
                          ? true
                          : false,
                      message: "PAN number is required",
                    },
                    {
                      pattern: /^[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}$/,
                      message: "Enter valid 10 alphanumeric PAN number",
                    },
                    {
                      min: 10,
                      max: 10,
                      message: "PAN No. must be 10 characters long",
                    },
                  ]}
                >
                  <Input
                    disabled={
                      gSTTypeValue === CompanyGSTTypes.Regular ||
                      gSTTypeValue === CompanyGSTTypes.Composition
                        ? true
                        : false
                    }
                    onChange={(e: any) => {
                      const capitalvalue = e.target.value.toUpperCase();
                      gstForm.setFieldValue("pan", capitalvalue);
                    }}
                  />
                </Form.Item>
              </>
            </>
            <Row justify="end" style={{ height: 32 }}>
              {!gstDisable && (
                <Space>
                  <Button
                    icon={<CloseOutlined />}
                    style={{ backgroundColor: "aliceblue" }}
                    onClick={() => {
                      setGSTDisable(true);
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    icon={<SaveOutlined />}
                    type="primary"
                    htmlType="submit"
                    loading={savebuttonloading}
                  >
                    Save
                  </Button>
                </Space>
              )}
            </Row>
          </Form>
        </>
      ),
    },
    // {
    //   key: "5",
    //   label: "General Setting",
    //   collapsible: "header",
    //   extra: (
    //     <>
    //       {generalDisable && (
    //         <Tooltip title="Edit">
    //           <FormOutlined
    //             className="ca-edit-btn"
    //             style={{ color: "rgb(106 119 227)" }}
    //             onClick={(e) => {
    //               handleIconClick(e, "5");
    //               setGeneralDisable(false);
    //               setGSTDisable(true);
    //               setInfoDisable(true);
    //               setDisable(true);
    //               setDetailsDisable(true);
    //             }}
    //           />
    //         </Tooltip>
    //       )}
    //     </>
    //   ),
    //   children: (
    //     <>
    //       <Form
    //         requiredMark={false}
    //         form={gstForm}
    //         labelAlign="left"
    //         disabled={generalDisable}
    //         autoComplete="off"
    //         layout="vertical"
    //         name="Gst"
    //         onFinish={(val) => {
    //           const data = {
    //             ...companyInfo,
    //             ...val,
    //           };
    //           console.log("data", val);

    //           setSaveButtonLoading(true);
    //           updateClientDetails!(data, currentClient?.id)
    //             .then((result: any) => {
    //               if (result?.status) {
    //                 setGeneralDisable(true);
    //                 openNotification(
    //                   "success",
    //                   "Setting updated successfully."
    //                 );
    //                 setSaveButtonLoading(false);
    //               } else {
    //                 openNotification("error", "There is some error.");
    //                 setSaveButtonLoading(false);
    //               }
    //             })
    //             .catch((ex: any) => {
    //               setSaveButtonLoading(false);
    //               openNotification("error", ex.message);
    //             });
    //         }}
    //       >
    //         <Form.Item
    //           name="showRCM"
    //           // className="m-10"
    //           className="input-setting-paymentTerm"
    //           layout="horizontal"
    //           valuePropName="checked"
    //         >
    //           <Checkbox>{highlightLabel("Show Reverse Charge (RCM)")}</Checkbox>
    //         </Form.Item>

    //         <Row justify="end" style={{ height: 32 }}>
    //           {!generalDisable && (
    //             <Space>
    //               <Button
    //                 icon={<CloseOutlined />}
    //                 style={{ backgroundColor: "aliceblue" }}
    //                 onClick={() => {
    //                   setGeneralDisable(true);
    //                 }}
    //               >
    //                 Cancel
    //               </Button>
    //               <Button
    //                 icon={<SaveOutlined />}
    //                 type="primary"
    //                 htmlType="submit"
    //                 loading={savebuttonloading}
    //               >
    //                 Save
    //               </Button>
    //             </Space>
    //           )}
    //         </Row>
    //       </Form>
    //     </>
    //   ),
    // },
    // {
    //   key: "5",
    //   label: "General Settings",
    //   collapsible: "header",
    //   extra: (
    //     <>
    //       {generalDisable && (
    //         <Tooltip title="Edit">
    //           <FormOutlined
    //             className="ca-edit-btn"
    //             style={{ color: "rgb(106 119 227)" }}
    //             onClick={(e) => {
    //               handleIconClick(e, "5");
    //               setGeneralDisable(false);
    //               setGSTDisable(true);
    //               setInfoDisable(true);
    //               setDisable(true);
    //               setDetailsDisable(true);
    //             }}
    //           />
    //         </Tooltip>
    //       )}
    //     </>
    //   ),
    //   children: (
    //     <>
    //       <Form
    //         requiredMark={false}
    //         form={generalForm}
    //         labelAlign="left"
    //         disabled={generalDisable}
    //         autoComplete="off"
    //         name="general"
    //         onFinish={(val) => {
    //           const data = {};
    //           console.log("data", val);

    //           setSaveButtonLoading(true);
    //           updateCompanySettings!(
    //             SettingsSections.GstDetails,
    //             {
    //               ...companySettings,
    //               // setting: {
    //               //   ...companySettings?.setting!,
    //               //   gstDetails: data?.gstDetails,
    //               // },
    //             },
    //             data
    //           )
    //             .then((result: any) => {
    //               if (result?.status) {
    //                 setGeneralDisable(true);
    //                 openNotification("success", "Setting updated successfully.");
    //                 setSaveButtonLoading(false);
    //               } else {
    //                 openNotification("error", "There is some error.");
    //                 setSaveButtonLoading(false);
    //               }
    //             })
    //             .catch((ex: any) => {
    //               setSaveButtonLoading(false);
    //               openNotification("error", ex.message);
    //             });
    //         }}
    //       >
    //         <Row>
    //           <Col xxl={6} xl={6} lg={12} md={12}>
    //             <Form.Item
    //               label="Enable Export"
    //               name={["generalSettings", "enableExport"]}
    //               className="inputBoxMb8 inputLabel33"
    //               layout="horizontal"
    //             >
    //               <Checkbox />
    //             </Form.Item>
    //           </Col>
    //           <Col xxl={6} xl={6} lg={12} md={12}>
    //             <Form.Item
    //               label="Enable Inventory"
    //               name={["generalSettings", "enableInventory"]}
    //               layout="horizontal"
    //               className="inputBoxMb8 inputLabel33"
    //             >
    //               <Checkbox />
    //             </Form.Item>
    //           </Col>
    //         </Row>
    //         <Row justify="end" style={{ height: 32 }}>
    //           {!generalDisable && (
    //             <Space>
    //               <Button
    //                 icon={<CloseOutlined />}
    //                 style={{ backgroundColor: "aliceblue" }}
    //                 onClick={() => {
    //                   setGeneralDisable(true);
    //                 }}
    //               >
    //                 Cancel
    //               </Button>
    //               <Button
    //                 icon={<SaveOutlined />}
    //                 type="primary"
    //                 htmlType="submit"
    //                 loading={saveButtonLoading}
    //               >
    //                 Save
    //               </Button>
    //             </Space>
    //           )}
    //         </Row>
    //       </Form>
    //     </>
    //   ),
    // },
  ];

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value;
    setSearchQuery(query);
    const matchingFields = findMatchingFieldLabels(query);

    if (matchingFields.length > 0) {
      setActivePopover(matchingFields[0].key);
    } else {
      setActivePopover(null);
    }
  };

  const filteredItems = items
    .filter((item) => {
      const matchingFields = findMatchingFieldLabels(searchQuery);
      return matchingFields.some((field) => field.key === item.key);
    })
    .map((item) => {
      const matchingFields = findMatchingFieldLabels(searchQuery);
      if (matchingFields?.length < 19) {
        const matchedField = matchingFields.find(
          (field) => field.key === item.key
        );
        console.log("matchedField", matchedField);

        if (matchedField) {
          return {
            ...item,
          };
        }
      }

      return item;
    });

  console.log("searchQuery", searchQuery);

  return (
    <div style={{ padding: "0px 0px 3px 0px", height: "80vh" }}>
      <div style={{ margin: "20px" }}>
        <Row justify={"center"}>
          <Col span={11}>
            <Input
              placeholder="Search settings..."
              value={searchQuery}
              onChange={handleSearchChange}
              prefix={
                <SearchOutlined style={{ color: "#aaa", fontSize: "18px" }} />
              }
              allowClear
              style={{
                // borderRadius: "24px",
                padding: "10px 16px",
                // boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                // borderBottom: "1px solid #d9d9d9",
                fontSize: "16px",
              }}
            />
          </Col>
        </Row>
      </div>
      <div
        style={{
          maxWidth: "724px",
          margin: "0 auto",
          maxHeight: "70vh",
          overflowY: "scroll",
        }}
      >
        <Card>
          <Collapse
            activeKey={activeKey}
            onChange={handleCollapseChange}
            items={filteredItems}
            // defaultActiveKey={["1"]}
          />
        </Card>
      </div>
    </div>
  );
};

export default SettingsCompanyInfo;
